import React from 'react';
import { useState } from 'react';
import SwiperCore from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import TriangleIcon from 'ui/SVG/TriangleIcon';
import PartnersCard from '../PartnersCard';
import data from './data';
import { childSettings, mainSettings } from './settings';
import './Slider.scss';
import SliderChild from './SliderChild';

const Labels = [
  "Partners",
  "Backers"
];

const Slider: React.FC = () => {
  const [mainSlider, setMainSlider] = useState<SwiperCore>(null);

  const onPrevSlide = () => {
  };

  const onNextSlide = () => {
  };

  return (
    <div className="partners__slider">
      <button className="partners__nav partners__nav_prev" onClick={onPrevSlide}>
        <TriangleIcon />
        <span>Partners</span>
      </button>
      <div className="partners__labels">
        <Swiper
          {...mainSettings}
          onInit={setMainSlider}
          className="partners__swiper partners__swiper_main"
        >
          {data.map((slide, idx) => (
            <SwiperSlide
              className="partners__slide partners__slide_main"
              key={idx}
            >
              <SliderChild index={idx} slide={slide} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <button className="partners__nav partners__nav_next" onClick={onNextSlide}>
        <span>Backers</span>
        <TriangleIcon />
      </button>
    </div>
  );
};

export default Slider;
